import { hasText } from "utils/helpers"
import "./media.less"
import { sanitizeEditorTextHtml } from "utils/html-sanitization"
import { useMessages } from "play/language/language"
import { useMemo } from "react"

interface Props {
  question: string | null | undefined
  className?: string
  reduceSizeOnSmallerScreens?: boolean
}

export default function PresentationQuestion(props: Props) {
  const msg = useMessages()

  const [question, isPdf] = useMemo(() => {
    if (props.question === null) {
      return ["", false]
    }
    const html = sanitizeEditorTextHtml(props.question)
    const isPdf = html.endsWith(".pdf")
    return [html, isPdf]
  }, [props.question])

  const isSmallText = useMemo(() => {
    const div = document.createElement("div")
    div.innerHTML = question
    const len = div.innerText.length
    const small = len < 80
    div.remove()
    return small
  }, [question])

  let className = ""
  if (isSmallText) {
    className += " small-text-length"
  } else {
    className += " large-text-length"
  }
  if (!!props.reduceSizeOnSmallerScreens) {
    className += " reduce-on-smaller-screens"
  }

  if (hasText(question)) {
    return (
      <div className={`question-outer ${props.className || ""}`}>
        {/* <div className="question-inner"> */}
        {isPdf ? (
          <div className={`question large-text-length`} draggable={false}>
            <p>{msg.nvoPdfInstructions}</p>
            <br />
            <a className="btn btn-primary" href={question} target="_blank">
              {msg.download}
            </a>
          </div>
        ) : (
          <div
            className={`question ${className}`}
            dangerouslySetInnerHTML={{ __html: question }}
            draggable={false}
            aria-label={msg.questionText}
          ></div>
        )}
        {/* </div> */}
      </div>
    )
  } else {
    return null
  }
}
